export default class Dropdown {
  constructor() {
    this.component = $(".esf-dropdown");
    this.init();
  }
  init() {
    const button = this.component.find(".esf-js-dropdown-trigger");

    button.click(function() {

      // Direct sibling
      const items = $(this).next(".esf-dropdown__items");

      items.toggleClass("-is-open");
    });
  }
}
